// src/App.jsx
import './App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import SignupStep1   from './pages/signup/SignupStep1';
import SignupStep2   from './pages/signup/SignupStep2';
import SignupStep3   from './pages/signup/SignupStep3';
import Login         from './pages/login/Login';
import ForgotPassword from './pages/login/ForgotPassword';
import DashboardRoutes from './pages/dashboard/DashboardRoutes';

export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        {/* public flows */}
        <Route path="/"                element={<SignupStep1 />} />
        <Route path="/signup/step-2"   element={<SignupStep2 />} />
        <Route path="/signup/step-3"   element={<SignupStep3 />} />
        <Route path="/login"           element={<Login />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />

        <Route path="/admin/*"   element={<DashboardRoutes />} />
        
      </Routes>
    </BrowserRouter>
  );
}
